import React, {useContext} from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {SiteFooter} from '@homeaway/react-site-footer';
import {SiteConfigContext} from '../context/SiteConfigContext';

const Footer = () => {
    const {sitename} = useContext(SiteConfigContext);
    const {footer} = useStaticQuery(graphql`
        query {
            footer {
                data
            }
        }
    `);
    const data = JSON.parse(footer.data);

    return <SiteFooter data={data} site={sitename} />;
};

export default Footer;
